import useForm from 'tennders-common/form/hooks/useForm'
import { useEffect, useState } from 'react'
import { defaultLineForm } from
  'tennders-finance/sales-invoice/components/multiple-sales-invoice/MultipleSalesInvoiceDiscountRow'
import { apiGet } from 'tennders-stracture/libs/api'
import PubSub from 'pubsub-js'
import { ceilDecimals, roundDecimals } from 'tennders-stracture/libs/utils'

const useMultipleSalesInvoiceDiscountRow = ({ costPrice, index, initialErrors, onFormChange }) => {
  const { form, setform: setForm, errors } = useForm({ initialForm: defaultLineForm, initialErrors })
  const [transaction, setTransaction] = useState(null)
  const onTransactionChange = (transaction) => {
    setTransaction(transaction)
    setForm({ ...form, transactionId: transaction.id, agreedPrice: transaction.totalPrice })
  }
  useEffect(() => {
    if (onFormChange) {
      onFormChange(index, form)
    }
  }, [onFormChange, index, form])

  const processForm = (key, value, form) => {
    const newForm = { ...form, [key]: value }
    if (key === 'vatPercentage' || key === 'amount' || key === 'value' || key === 'applyTo') {
      newForm.amount = roundDecimals((newForm.value * costPrice) / 100)
      const percentage = newForm.vatPercentage ? (parseFloat(newForm.vatPercentage) / 100) : 0
      const amount = parseFloat(newForm.amount)
      const vatAmount = amount * percentage
      newForm.totalAmount = amount + vatAmount
      newForm.vatAmount = vatAmount
    }
    return newForm
  }

  useEffect(() => {
    setForm(prevState => processForm('value', prevState.value || 0, prevState))
  }, [costPrice])

  const onChange = (key, value) => {
    setForm(prev => processForm(key, value, prev))
  }

  const fetchTransactionDetail = async (id) => {
    // eslint-disable-next-line max-len
    const data = await apiGet('/transactions/' + id, { query: { attributes: '{id,referenceNumber,createdAt {d}, matchedTruck{totalPrice, bookRate, id, paymentTerm{days}, cmrDocument{name, fullUri}},salesInvoice{id, uniqueFileName}, hasSalesInvoice, costInvoices{id}}' } })
    setTransaction(data)
    onChange('transactionId', id)
  }

  useEffect(() => {
    const unsubscribe = PubSub.subscribe(`multiple-sales-invoice-discount:${index}:change`, (msg, data) => {
      if (data.transactionId) {
        fetchTransactionDetail(data.transactionId)
      }
      setForm(prevState => ({ ...prevState, ...data }))
    })
    return () => PubSub.unsubscribe(unsubscribe)
  }, [index])

  return {
    onChange,
    form,
    setForm,
    errors,
    onTransactionChange,
    transaction

  }
}

export default useMultipleSalesInvoiceDiscountRow
